export const PROPOSAL_BATCH_TABLE = "proposalBatches"
// `*participantChatIds` is a Dexie multi-entry index — every chat id in the
// array becomes its own primary-key entry, so a `where("participantChatIds")
// .equals(chatId)` query returns the batch when the current chat is one of
// the dedup-group mirror rows. Mirrors `pre_order_messages` per-participant
// rows for shared pre-orders.
export const PROPOSAL_BATCH_TABLE_SCHEMA =
  "id, companyId, userId, groupId, status, toolName, syncId, [sourceChannelType+sourceChatId], *participantChatIds"
